export default {
  line1: 'Sistema eFactura by Unifiedpost',
  line2: `${new Date().getFullYear()} Unifiedpost Group`,
  line3: 'soporte.sistemaefactura@unifiedpost.com',
  jcyl: {
    line3: 'igacyl.factura@jcyl.es'
  }
}